module.exports = __webpack_public_path__ + "static/media/beta-landing-asset-2.a5eed1f2.svg";